// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"f90ef0a1","213":"25a678aa","290":"4dadc823","358":"21f3e434","453":"186f88bd","604":"b70c4d76","667":"8e261f73","688":"f6e933a7"}[chunkId] + ".chunk.js";
};